module.exports = __webpack_public_path__ + "img/d59c6275-bece-48b9-8f04-7ef52e9c7ec9_base_resized.06823174.jpg";